import { ArrowRight, Minus, Plus, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "../lib/cart";
export default function CartPage() {
  const { items, total, updateQuantity, removeItem } = useCart();
  return (
    <section className="page content-page">
      <div className="page-title">
        <span>Your selection</span>
        <h1>Cart</h1>
      </div>
      {!items.length ? (
        <>
          <p>Your cart is empty.</p>
          <Link className="outline-btn" to="/shop">
            Browse products
          </Link>
        </>
      ) : (
        <>
          <div className="cart-list">
            {items.map((i) => (
              <div className="cart-item" key={i.id}>
                <div>
                  <b>{i.displayName || i.name}</b>
                  <small>{i.sku}</small>
                </div>
                <div className="cart-item-right">
                  <button onClick={() => updateQuantity(i.id, i.quantity - 1)}>
                    <Minus />
                  </button>
                  <span>{i.quantity}</span>
                  <button onClick={() => updateQuantity(i.id, i.quantity + 1)}>
                    <Plus />
                  </button>
                  <b>₹{Number(i.price * i.quantity).toLocaleString("en-IN")}</b>
                  <button onClick={() => removeItem(i.id)}>
                    <Trash2 />
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className="checkout-total">
            <span>Total</span>
            <strong>₹{total.toLocaleString("en-IN")}</strong>
          </div>
          <Link className="outline-btn" to="/checkout">
            Checkout <ArrowRight size={16} />
          </Link>
        </>
      )}
    </section>
  );
}
